import { definePreset } from "@primevue/themes";
import Aura from "@primevue/themes/aura";

const createPreset = (options?: any) => {
    return definePreset(Aura, {
        ...(options ?? {}),
    });
};

export default createPreset;
